import { useMutation } from '@apollo/client';

import { SendDummyQuoteInput } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';

import { SendDummyQuoteDocument } from './graphql/sendDummyQuote.gql';

const useSendDummyQuoteToUser = () => {
  const { companyProfileId } = useCompanyContext();
  if (!companyProfileId) {
    throw new Error(
      'companyProfile is undefined in useSendDummyQuoteToUser hook',
    );
  }

  const [sendDummyQuote, { loading }] = useMutation(SendDummyQuoteDocument);

  const sendDummyQuoteToUser = async (variables: {
    input: SendDummyQuoteInput;
  }) => sendDummyQuote({ variables });

  return { loading, sendDummyQuoteToUser };
};

export default useSendDummyQuoteToUser;
